<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" md="9">
        <h1 class="text-h4 mb-2">Detail Wilayah</h1>
        <div class="body-1 text--secondary">
          Informasi detail, seperti nama dan lokasi, data yang berkaitan
        </div>
      </v-col>
    </v-row>
    <v-row justify="center" class="my-4">
      <v-col cols="12" md="3">
        <v-card outlined>
          <v-img
            v-if="unit.unitImage"
            :src="unit.unitImage"
            width="100%"
            max-height="150"
          />
          <v-card-text>
            <v-row dense>
              <v-col>
                <v-list-item-title
                  class="body-2 grey--text text--darken-2 mt-2"
                >
                  <p class="caption grey--text text-lighten-4 mb-1">
                    Nama
                  </p>
                  {{ unit.unitName || '-' }}
                </v-list-item-title>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col>
                <v-list-item-title
                  class="body-2 grey--text text--darken-2 mt-2"
                >
                  <p class="caption grey--text text-lighten-4 mb-1">
                    Provinsi
                  </p>
                  {{ unit.unitProvinceName || '-' }}
                </v-list-item-title>
              </v-col>
              <v-col>
                <v-list-item-title
                  class="body-2 grey--text text--darken-2 mt-2"
                >
                  <p class="caption grey--text text-lighten-4 mb-1">
                    Kota
                  </p>
                  {{ unit.unitCityName || '-' }}
                </v-list-item-title>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col>
                <v-list-item-title
                  class="body-2 grey--text text--darken-2 mt-2"
                >
                  <p class="caption grey--text text-lighten-4 mb-1">
                    Kecamatan
                  </p>
                  {{ unit.unitSubdistrictName || '-' }}
                </v-list-item-title>
              </v-col>
              <v-col>
                <v-list-item-title
                  class="body-2 grey--text text--darken-2 mt-2"
                >
                  <p class="caption grey--text text-lighten-4 mb-1">
                    Kelurahan
                  </p>
                  {{ unit.unitDistrictName || '-' }}
                </v-list-item-title>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col>
                <v-list-item-title
                  class="body-2 grey--text text--darken-2 mt-2"
                >
                  <p class="caption grey--text text-lighten-4 mb-1">
                    Status
                  </p>
                  <span
                    :class="unit.unitIsActive * 1 ? 'green--text' : 'red--text'"
                    class="transparent"
                  >
                    {{ unit.unitIsActive * 1 ? 'Aktif' : 'Non-Aktif' }}
                  </span>
                </v-list-item-title>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-container class="py-0">
          <v-row>
            <v-col cols="12">
              <v-card outlined>
                <v-tabs class="custom-tabs" color="light-green">
                  <v-tab class="text-capitalize">
                    Lokasi
                  </v-tab>
                </v-tabs>
                <v-card flat>
                  <v-card-text>
                    <v-img>
                      <gmap-map
                        ref="gmap"
                        :center="center"
                        :zoom="18"
                        :scrollwheel="false"
                        map-type-id="satellite"
                        style="width:100%;  height: 50vh;"
                      >
                        <gmap-marker
                          v-for="(item, index) in markers"
                          :key="index"
                          :position="item.position"
                          :icon="item.icon"
                          @click="toggleInfoWindow(item, index)"
                        >
                        </gmap-marker>

                        <gmap-info-window
                          :options="{
                            pixelOffset: {
                              width: 0,
                              height: -20
                            }
                          }"
                          :position="infoWindowPos"
                          :opened="infoWinOpen"
                          @closeclick="infoWinOpen = false"
                        >
                          <div v-html="infoContent"></div>
                        </gmap-info-window>
                      </gmap-map>
                    </v-img>
                  </v-card-text>
                </v-card>
              </v-card>
            </v-col>
            <v-col cols="12" v-if="unit.unitType === 'desa'">
              <v-card outlined>
                <v-tabs class="custom-tabs" color="light-green">
                  <v-tab class="text-capitalize">
                    Informasi Desa
                  </v-tab>
                </v-tabs>
                <v-card flat>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12">
                        <v-row dense>
                          <v-col>
                            <v-list-item-title
                              class="body-2 grey--text text--darken-2 mt-2"
                            >
                              <p class="caption grey--text text-lighten-4 mb-1">
                                jumlah Penduduk
                              </p>
                              {{ unit.unitJumlahPenduduk | number }}
                              Orang
                            </v-list-item-title>
                          </v-col>
                          <v-col>
                            <v-list-item-title
                              class="body-2 grey--text text--darken-2 mt-2"
                            >
                              <p class="caption grey--text text-lighten-4 mb-1">
                                Kondisi Geografis
                              </p>
                              {{ unit.unitKondisiGeografis || '-' }}
                            </v-list-item-title>
                          </v-col>
                          <v-col>
                            <v-list-item-title
                              class="body-2 grey--text text--darken-2 mt-2"
                            >
                              <p class="caption grey--text text-lighten-4 mb-1">
                                Kerawanan
                              </p>
                              {{ unit.unitKerawanan || '-' }}
                            </v-list-item-title>
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="4">
                            <v-list-item-title
                              class="body-2 grey--text text--darken-2 mt-2"
                            >
                              <p class="caption grey--text text-lighten-4 mb-1">
                                Bencana Alam
                              </p>
                              {{ unit.unitBencanaAlam || '-' }}
                            </v-list-item-title>
                          </v-col>
                          <v-col cols="4">
                            <v-list-item-title
                              class="body-2 grey--text text--darken-2 mt-2"
                            >
                              <p class="caption grey--text text-lighten-4 mb-1">
                                Konstelasi Politik
                              </p>
                              {{ unit.unitKonstelasiPolitik || '-' }}
                            </v-list-item-title>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-card>
            </v-col>
            <v-col cols="12" v-if="unit.admin">
              <v-card outlined>
                <v-tabs class="custom-tabs" color="light-green">
                  <v-tab class="text-capitalize">
                    Admin
                  </v-tab>
                </v-tabs>
                <v-card flat>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" md="4">
                        <v-avatar
                          class="d-block mx-auto"
                          :color="
                            unit.admin.accountAvatar
                              ? 'white'
                              : 'grey lighten-2'
                          "
                          width="108"
                          height="108"
                        >
                          <v-img
                            :src="unit.admin.accountAvatar"
                            :alt="unit.admin.accountName"
                          />
                        </v-avatar>
                      </v-col>
                      <v-col cols="12" md="8">
                        <v-row dense>
                          <v-col>
                            <v-list-item-title
                              class="body-2 grey--text text--darken-2 mt-2"
                            >
                              <p class="caption grey--text text-lighten-4 mb-1">
                                Nama
                              </p>
                              {{ unit.admin.accountName || '-' }}
                            </v-list-item-title>
                          </v-col>
                          <v-col>
                            <v-list-item-title
                              class="body-2 grey--text text--darken-2 mt-2"
                            >
                              <p class="caption grey--text text-lighten-4 mb-1">
                                NRP/NIK
                              </p>
                              {{ unit.admin.accountCode || '-' }}
                            </v-list-item-title>
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col>
                            <v-list-item-title
                              class="body-2 grey--text text--darken-2 mt-2"
                            >
                              <p class="caption grey--text text-lighten-4 mb-1">
                                No Telepon
                              </p>
                              {{ unit.admin.accountMobilephone || '-' }}
                            </v-list-item-title>
                          </v-col>
                          <v-col>
                            <v-list-item-title
                              class="body-2 grey--text text--darken-2 mt-2"
                            >
                              <p class="caption grey--text text-lighten-4 mb-1">
                                Email
                              </p>
                              {{ unit.admin.accountEmail || '-' }}
                            </v-list-item-title>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-card>
            </v-col>
            <v-col cols="12" v-if="unit.unitTokohDaerah">
              <v-card outlined>
                <v-tabs class="custom-tabs" color="light-green">
                  <v-tab class="text-capitalize">
                    Tokoh Daerah
                  </v-tab>
                </v-tabs>
                <v-card flat>
                  <v-card-text>
                    <div
                      v-if="unit.unitTokohDaerah.length < 1"
                      class="text-center font-italic"
                    >
                      Belum ada tokoh tedaftar
                    </div>
                    <v-row
                      v-else
                      dense
                      v-for="(tokoh, key) in unit.unitTokohDaerah"
                      :key="`toda ${key}`"
                    >
                      <v-col>
                        <v-list-item-title
                          class="body-2 grey--text text--darken-2 mt-2"
                        >
                          <p class="caption grey--text text-lighten-4 mb-1">
                            Nama
                          </p>
                          {{ tokoh.nama || '-' }}
                        </v-list-item-title>
                      </v-col>
                      <v-col>
                        <v-list-item-title
                          class="body-2 grey--text text--darken-2 mt-2"
                        >
                          <p class="caption grey--text text-lighten-4 mb-1">
                            Jabatan
                          </p>
                          {{ tokoh.jabatan || '-' }}
                        </v-list-item-title>
                      </v-col>
                      <v-col>
                        <v-list-item-title
                          class="body-2 grey--text text--darken-2 mt-2"
                        >
                          <p class="caption grey--text text-lighten-4 mb-1">
                            No Telepon
                          </p>
                          {{ tokoh.noHandphone || '-' }}
                        </v-list-item-title>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-card>
            </v-col>
            <v-col cols="12" v-if="unit.unitTokohMasyarakat">
              <v-card outlined>
                <v-tabs class="custom-tabs" color="light-green">
                  <v-tab class="text-capitalize">
                    Tokoh Masyarakat
                  </v-tab>
                </v-tabs>
                <v-card flat>
                  <v-card-text>
                    <div
                      v-if="unit.unitTokohMasyarakat.length < 1"
                      class="text-center font-italic"
                    >
                      Belum ada tokoh tedaftar
                    </div>
                    <v-row
                      v-else
                      dense
                      v-for="(tokoh, key) in unit.unitTokohMasyarakat"
                      :key="`tomas ${key}`"
                    >
                      <v-col>
                        <v-list-item-title
                          class="body-2 grey--text text--darken-2 mt-2"
                        >
                          <p class="caption grey--text text-lighten-4 mb-1">
                            Nama
                          </p>
                          {{ tokoh.nama || '-' }}
                        </v-list-item-title>
                      </v-col>
                      <v-col>
                        <v-list-item-title
                          class="body-2 grey--text text--darken-2 mt-2"
                        >
                          <p class="caption grey--text text-lighten-4 mb-1">
                            Jabatan
                          </p>
                          {{ tokoh.jabatan || '-' }}
                        </v-list-item-title>
                      </v-col>
                      <v-col>
                        <v-list-item-title
                          class="body-2 grey--text text--darken-2 mt-2"
                        >
                          <p class="caption grey--text text-lighten-4 mb-1">
                            No Telepon
                          </p>
                          {{ tokoh.noHandphone || '-' }}
                        </v-list-item-title>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-card>
            </v-col>
            <v-col cols="12" v-if="unit.unitTokohAgama">
              <v-card outlined>
                <v-tabs class="custom-tabs" color="light-green">
                  <v-tab class="text-capitalize">
                    Tokoh Agama
                  </v-tab>
                </v-tabs>
                <v-card flat>
                  <v-card-text>
                    <div
                      v-if="unit.unitTokohMasyarakat.length < 1"
                      class="text-center font-italic"
                    >
                      Belum ada tokoh tedaftar
                    </div>
                    <v-row
                      v-else
                      dense
                      v-for="(tokoh, key) in unit.unitTokohAgama"
                      :key="`toga ${key}`"
                    >
                      <v-col>
                        <v-list-item-title
                          class="body-2 grey--text text--darken-2 mt-2"
                        >
                          <p class="caption grey--text text-lighten-4 mb-1">
                            Nama
                          </p>
                          {{ tokoh.nama || '-' }}
                        </v-list-item-title>
                      </v-col>
                      <v-col>
                        <v-list-item-title
                          class="body-2 grey--text text--darken-2 mt-2"
                        >
                          <p class="caption grey--text text-lighten-4 mb-1">
                            Jabatan
                          </p>
                          {{ tokoh.jabatan || '-' }}
                        </v-list-item-title>
                      </v-col>
                      <v-col>
                        <v-list-item-title
                          class="body-2 grey--text text--darken-2 mt-2"
                        >
                          <p class="caption grey--text text-lighten-4 mb-1">
                            No Telepon
                          </p>
                          {{ tokoh.noHandphone || '-' }}
                        </v-list-item-title>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import unit from '@/mixins/unit';
import map from '@/mixins/map';
export default {
  mixins: [unit, map],
  async mounted() {
    const unit = await this.getUnit(this.$route.params.id);
    this.insertMarker(unit.unitLatitude, unit.unitLongitude, unit);
  },
  methods: {
    getInfoWindowContent(marker) {
      return `
          <div id="iw-container">
            <div class="iw-title">
              Posisi ${marker.content.unitName}
            </div>
            <div class="iw-content">
              Latitude: ${marker.content.unitLatitude}
              Longititude: ${marker.content.unitLongitude}
            </div>
          </div>
        `;
    }
  }
};
</script>
